import AddButton from '../../../components/Buttons/AddButton';
import {
  toggleMultipleStartlist,
  updateRegistration,
} from '../../../api/Registrations';
import { useState } from 'react';
import RaceClassBulkDropdown from './RaceClassBulkDropdown';
import RemoveButton from '../../../components/Buttons/RemoveButton';
import { Dropdown, Spinner } from 'react-bootstrap';

function RegistrationBulkMenuBtns({
  competitionId,
  competitionStatus,
  selectedElements,
  registrations,
  setRegistrations,
  setBulkRegistrationStatusesSuccess,
  setRegistrationStatusesFailToast,
  setRaceClassBulkInfo,
  raceClassBulkInfo,
  setBulkStartlistToast,
}) {
  const [toggleStartlistLoading, setToggleStartlistLoading] = useState(false);
  const [unregisterLoading, setUnregisterLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);

  const updateRegistrations = async (shouldBeRegistered) => {
    const selectedElementIds = selectedElements
      .filter((e) => e.participantId)
      .map((e) => e.participantId);

    const selectedElementEmails = selectedElements
      .filter((e) => e.participantDetails.email && !e.participantId)
      .map((e) => e.participantDetails.email);

    const result = await updateRegistration(
      competitionId,
      shouldBeRegistered,
      selectedElementIds,
      selectedElementEmails
    );

    if (result.statusCode === 200) {
      setRegistrations(result.registrations);

      let obj = {
        show: true,
      };

      if (shouldBeRegistered) {
        obj = {
          ...obj,
          headerText: 'Återanmälningar lyckades!',
          bodyText: 'De valda objekten är nu återanmälda',
        };
      } else {
        obj = {
          ...obj,
          headerText: 'Avanmälningar lyckades!',
          bodyText: 'De valda objekten är nu avanmälda',
        };
      }

      setBulkRegistrationStatusesSuccess(obj);
      return true;
    } else {
      let failToastObj = {
        title: 'Fel',
        show: true,
      };

      if (result.statusCode === 409) {
        failToastObj.body = result.errorMessage;
      } else {
        failToastObj.body = 'De valda objekten kunde inte avanmälas.';
      }

      setRegistrationStatusesFailToast(failToastObj);
      return false;
    }
  };

  const handleMoveToStartlist = async () => {
    setToggleStartlistLoading(true);

    const res = await toggleMultipleStartlist(
      competitionId,
      selectedElements,
      true
    );

    if (res.statusCode === 200) {
      let updatedList = registrations.map((r) => {
        const index = selectedElements.findIndex(
          (e) => e.racingNumber === r.racingNumber
        );
        if (index > -1) {
          return { ...r, inStartlist: true };
        } else {
          return r;
        }
      });
      setRegistrations(updatedList);
      setBulkStartlistToast({
        type: 'success',
        title: 'Flytt till startlistan lyckades!',
        body: 'De valda objekten flyttades till startlistan.',
        show: true,
      });
    } else {
      setBulkStartlistToast({
        type: 'danger',
        title: 'Flytt till startlistan misslyckades',
        body: 'De valda objekten kunde inte flyttas till startlistan.',
        show: true,
      });
    }
    setToggleStartlistLoading(false);
  };

  return (
    <div>
      <Dropdown className='d-block d-lg-none' autoClose='outside'>
        <Dropdown.Toggle variant='outline-primary'>
          Välj handling{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={handleMoveToStartlist}
            disabled={
              competitionStatus !== 'Kommande' &&
              competitionStatus !== 'Pågående'
            }
          >
            Flytta till startlista{' '}
            {toggleStartlistLoading && (
              <>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='me-2'
                />
                <span className='visually-hidden'>Loading...</span>
              </>
            )}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() =>
              setRaceClassBulkInfo({
                ...raceClassBulkInfo,
                modalShow: true,
                mobileMode: true,
              })
            }
            disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
          >
            Redigera tävlingsklass{' '}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={async () => {
              setUnregisterLoading(true);
              await updateRegistrations(false);
              setUnregisterLoading(false);
            }}
            disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
          >
            Avanmäl{' '}
            {unregisterLoading && (
              <>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='me-2'
                />
                <span className='visually-hidden'>Loading...</span>
              </>
            )}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={async () => {
              setRegisterLoading(true);
              await updateRegistrations(true);
              setRegisterLoading(false);
            }}
            disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
          >
            Återanmäl{' '}
            {registerLoading && (
              <>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='me-2'
                />
                <span className='visually-hidden'>Loading...</span>
              </>
            )}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <div className='d-none d-lg-flex gap-3'>
        <AddButton
          text='Flytta till startlista'
          variant='outline-primary'
          className='outline-primary'
          loading={toggleStartlistLoading}
          onClick={handleMoveToStartlist}
          disabled={
            competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'
          }
        />

        <RaceClassBulkDropdown
          selectedElements={selectedElements}
          setRaceClassBulkInfo={setRaceClassBulkInfo}
          raceClassBulkInfo={raceClassBulkInfo}
          disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
        />

        <RemoveButton
          text='Avanmäl'
          variant='outline-primary'
          className='outline-primary'
          loading={unregisterLoading}
          onClick={async () => {
            setUnregisterLoading(true);
            await updateRegistrations(false);
            setUnregisterLoading(false);
          }}
          disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
        />
        <AddButton
          text='Återanmäl'
          variant='outline-primary'
          className='outline-primary'
          loading={registerLoading}
          onClick={async () => {
            setRegisterLoading(true);
            await updateRegistrations(true);
            setRegisterLoading(false);
          }}
          disabled={competitionStatus !== 'Kommande' && competitionStatus !== 'Pågående'}
        />
      </div>
    </div>
  );
}

export default RegistrationBulkMenuBtns;
